import React, { useEffect, useRef } from 'react'
import { BaseView, BaseText } from '@/components/base'

interface SwitchButtonAnimatedProps {
  leftLabel: string
  rightLabel: string
  isLeftButtonActive: boolean
  onLeftTabClicked: () => void
  onRightTabClicked: () => void
}

const CONTAINER_WIDTH = 280
const CONTAINER_HEIGHT = 49
const TAB_SIZE = CONTAINER_WIDTH / 2

export const SwitchButtonAnimated: React.FC<SwitchButtonAnimatedProps> = ({
  leftLabel,
  rightLabel,
  isLeftButtonActive,
  onLeftTabClicked,
  onRightTabClicked,
}) => {
  const indicatorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (indicatorRef.current) {
      const translateX = isLeftButtonActive ? 0 : TAB_SIZE - 4
      indicatorRef.current.style.transform = `translateX(${translateX}px)`
    }
  }, [isLeftButtonActive])

  return (
    <BaseView
      className="bg-[#242426] rounded-full p-1 relative overflow-hidden"
      style={{
        width: CONTAINER_WIDTH,
        height: CONTAINER_HEIGHT,
      }}
    >
      {/* Animated indicator */}
      <div
        ref={indicatorRef}
        className="absolute top-1 bottom-1 bg-white rounded-full transition-transform duration-300 ease-in-out shadow-lg border border-gray-300"
        style={{
          width: TAB_SIZE - 8,
          left: 4,
          zIndex: 5,
          opacity: 0.9,
        }}
      />

      {/* Buttons */}
      <BaseView row className="relative" style={{ zIndex: 10 }}>
        {/* Left Button */}
        <button
          onClick={onLeftTabClicked}
          className="flex-1 rounded-full transition-all duration-200 hover:opacity-80 flex items-center justify-center"
          style={{
            paddingBottom: 3,
            height: CONTAINER_HEIGHT - 6,
          }}
        >
          <BaseText
            fontFamily="semibold"
            className="font-medium transition-colors"
            style={{
              fontSize: 18,
              color: isLeftButtonActive ? '#111827' : '#ffffff',
            }}
          >
            {leftLabel}
          </BaseText>
        </button>

        {/* Right Button */}
        <button
          onClick={onRightTabClicked}
          className="flex-1 rounded-full transition-all duration-200 hover:opacity-80 flex items-center justify-center"
          style={{
            paddingBottom: 3,
            height: CONTAINER_HEIGHT - 6,
          }}
        >
          <BaseText
            className="font-medium transition-colors"
            fontFamily="semibold"
            style={{
              fontSize: 18,
              color: !isLeftButtonActive ? '#111827' : '#ffffff',
            }}
          >
            {rightLabel}
          </BaseText>
        </button>
      </BaseView>
    </BaseView>
  )
}
